export enum PlacementTaskStatus {
    Planned = 'Planned',
    InProgress = 'InProgress',
    Completed = 'Completed',
    Skipped = 'Skipped',
}
